import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, IconButton, Select, MenuItem, Avatar,
  Menu, Box,useMediaQuery,
  InputBase } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
//import logo from '../images/foodsakzsidelogo.png';
import { useCart } from '../context/CartContext';




const Header = () => {
     const { i18n } = useTranslation();
         const navigate = useNavigate();
     const { cart } = useCart();
  const isMobile = useMediaQuery('(max-width:768px)');

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
    

    
  return (
    <AppBar position="static" color="default"  >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>

{/* Logo */}
<Box
  component="img"
  src={!isMobile ? "../images/foodsakzsidegraylogo.png" : "../images/mobilelogo.png"}
  alt="FoodSakz Logo"  
  sx={{ 
    height: 60,
    cursor: "pointer",
  }}
  onClick={() => navigate("/")}
 />
       


      <Select
          value={i18n.language}
          onChange={(e) => changeLanguage(e.target.value)}
          variant="outlined"
          size="small"
          sx={{ bgcolor: 'white', color: 'black' }}
        >
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="fr">Français</MenuItem>
          <MenuItem value="es">Español</MenuItem>
          <MenuItem value="ar">العربية</MenuItem>
          <MenuItem value="ta">தமிழ்</MenuItem>
        </Select>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
